import { render, staticRenderFns } from "./port.vue.html?vue&type=template&id=2517e146"
import script from "./port.controller?vue&type=script&lang=js&external"
export * from "./port.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports